import React, { Component, useEffect, useState, useMemo } from "react";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
// import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { fetchUser, getData } from "../../util/API";
import { message } from "antd/lib/index";
import { fetchUserInfo } from "../../appRedux/actions/Auth";
import "./style.less";

const { SubMenu } = Menu;

const SidebarContentComp = (props) => {
  const [escalateTaskCount, setEscalateTaskCount] = useState(0);

  useEffect(() => {
    fetchConflictTickets();
  }, []);

  const fetchConflictTickets = () => {
    const endpoint = "/management/escalation-task-count/";
    getData(endpoint)
      .then((res) => {
        if (res.data && res.data.status === 200 && res.data.count) {
          setEscalateTaskCount(res.data.count.total_records);
        } else {
          setEscalateTaskCount(0);
        }
      })
      .catch((error) => {
        setEscalateTaskCount(0); // Error case
        console.error("Error fetching escalation task count:", error);
      });
  };

  const handleClick = (e) => {
    // console.log('click ', e);
  };
  let { navStyle, themeType } = useSelector(({ settings }) => settings);
  // console.log(navStyle, 'navvvvvvvvv/vv', themeType)
  let { pathname } = useSelector(({ common }) => common);
  // console.log("pathname => ", pathname)

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  // console.log("selectedKeys -> ", selectedKeys)

  let user = props.user.data;
  if (!user) {
    return <></>;
  }

  let info = user["LogedInUserInfo"];
  // console.log(info,'infoooo..')
  const user_role = localStorage.getItem("user_role");
  const role = localStorage.getItem("all_roles").split(",");
  
  // Determine default open category based on user's default page from SignIn.js
  const getDefaultOpenCategory = () => {
    const logedInTo = localStorage.getItem("loged_in_to");

    // Default pages from SignIn.js redirects
    if (user_role === "coordinator") {
      return "tasks-tickets"; // Default: /tasks
    } else if (user_role === "project_manager") {
      // SignIn.js line 152 redirects to /project, but most menu items are in tasks-tickets
      // Check if current pathname suggests projects category
      if (
        pathname &&
        (pathname.includes("project-list") ||
          pathname.includes("project-create") ||
          pathname.includes("project-reports"))
      ) {
        return "projects";
      }
      return "tasks-tickets"; // Default: /tasks (most common)
    } else if (user_role === "admin") {
      if (logedInTo === "pmt") {
        return "tasks-tickets"; // Default: /tasks
      }
      return null; // Other portals
    } else if (user_role === "data_entry") {
      return "tasks-tickets"; // Default: /tasks
    } else if (
      user_role === "client_user" ||
      user_role === "client_manager" ||
      user_role === "client_admin"
    ) {
      return "projects"; // Default: /client-project-list
    } else if (user_role === "qc") {
      return "tasks-tickets"; // Default: /qc-ticket-list
    } else if (user_role === "auditor_user") {
      return "operations"; // Default: /audit-documents
    } else if (user_role === "customer_connect") {
      return "operations"; // Default: /raw-address
    } else if (user_role === "kci") {
      return "tasks-tickets"; // Default: /kci-tasks
    } else if (user_role === "verify_scheduler") {
      return "operations"; // Default: /verify-schedule
    }
    return null;
  };

  const defaultOpenCategory = getDefaultOpenCategory();
  // console.log(role, role.includes("auditor_user"))
  // const user_role = "accountant"
  // const status = info.status? info.status:"pending"
  // const myprofile_link = '/detail/'.concat(info.uuid)
  // console.log(user_role,'user role.........!')

  // Define ordered menu items for each role
  const getOrderedMenuItems = () => {
    // Coordinator role order
    const coordinatorOrder = [
      "coordinator-dashboard",
      "coordinator-project-list",
      "tasks",
      "tasks-dashboard",
      "ticket-list",
      "invoice-requests",
      "partner-invoices",
      "create-ticket",
      "work-order-list",
      "bulk-document-upload-link-generator",
      "escalate-tasks",
      "project-expense",
      "spare-management",
      "raw-address",
      "notification-dashboard",
      "create-techlocal-ticket",
      "escalate",
      "tools",
      "chat",
      "to-do",
      "create-kci",
      "customer-profiling",
      "auto-allocate",
      "customer-profiling",
      "compare-proposal",
    ];

    // Project Manager and Admin role order
    const pmAdminOrder = [
      "manager-dashboard",
      "analytics-dashboard",
      "tickets-scheduled-today",
      "partner-dashboard",
      "tasks",
      "audit-documents",
      "escalate-tasks",
      "ticket-list",
      "create-ticket",
      "project-list",
      "project-reports",
      "project-expense",
      "spare-management",
      "partner-invoices",
      "work-order-list",
      "invoice-requests",
      "raw-address",
      "report-automation",
      "notification-dashboard",
      "escalate_dashboard",
      "takeout",
      "asset-home",
      "create-techlocal-ticket",
      "bulk-document-upload-link-generator",
      "tools",
      "techlocal-users",
      "chat",
      "to-do",
      "surveys",
      "create-kci",
      "customer-profiling",
      "whatsapp-msg",
      "auto-allocate",
      "compare-proposal",
    ];

    // Client roles order
    const clientOrder = [
      "client-dashboard",
      "ticket-progress",
      "client-tasks",
      "client-project-list",
      "client-project-create-edit",
      "client-create-ticket",
    ];

    // QC role order
    const qcOrder = ["qc-ticket-list", "qc-tasks"];

    // KCI role order
    const kciOrder = ["kci-tasks", "create-kci"];

    // Verify Scheduler role order
    const verifySchedulerOrder = ["verify-schedule"];

    // Auditor role order
    const auditorOrder = ["audit-documents", "audit-visits"];

    // Customer Connect role order
    const customerConnectOrder = [
      "raw-address",
      "escalate-tasks",
      "chat",
      "to-do",
      "create-kci",
    ];

    // Data Entry role order
    const dataEntryOrder = ["tasks", "project-expense"];

    // menu order based on role
    if (user_role === "coordinator") {
      return coordinatorOrder;
    } else if (user_role === "project_manager" || user_role === "admin") {
      return pmAdminOrder;
    } else if (
      user_role === "client_admin" ||
      user_role === "client_user" ||
      user_role === "client_manager"
    ) {
      return clientOrder;
    } else if (user_role === "qc") {
      return qcOrder;
    } else if (user_role === "kci") {
      return kciOrder;
    } else if (user_role === "verify_scheduler") {
      return verifySchedulerOrder;
    } else if (user_role === "customer_connect") {
      return customerConnectOrder;
    } else if (user_role === "data_entry") {
      return dataEntryOrder;
    } else if (role.includes("auditor_user")) {
      return auditorOrder;
    }
    return [];
  };

  // Define all menu items with their configurations (only ordered items)
  const menuItems = {
    "coordinator-dashboard": {
      roles: ["coordinator"],
      component: (
        <Menu.Item key="coordinator-dashboard">
          <Link to="/coordinator-dashboard">
            <i className="icon icon-dasbhoard" />
            <span>Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "manager-dashboard": {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="manager-dashboard">
          <Link to="/manager-dashboard">
            <i className="icon icon-dasbhoard" />
            <span>Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "analytics-dashboard": {
      roles: ["admin", "project_manager"],
      component: (
        <Menu.Item key="analytics-dashboard">
          <Link to="/analytics-dashboard">
            <i className="icon icon-dasbhoard" />
            <span>Analytics Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "partner-dashboard": {
      roles: ["admin"],
      component: (
        <Menu.Item key="partner-dashboard">
          <Link to="/partner-dashboard">
            <i className="icon icon-dasbhoard" />
            <span>Partner Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "coordinator-project-list": {
      roles: ["coordinator"],
      component: (
        <Menu.Item key="coordinator-project-list">
          <Link to="/coordinator-project-list">
            <i className="icon icon-data-display" />
            <span>Projects</span>
          </Link>
        </Menu.Item>
      ),
    },
    tasks: {
      roles: ["project_manager", "admin", "data_entry", "coordinator"],
      component: (
        <Menu.Item key="tasks">
          <Link to="/tasks">
            <Icon type="unordered-list" />
            <span>Tasks</span>
          </Link>
        </Menu.Item>
      ),
    },
    "tasks-dashboard": {
      roles: ["coordinator"],
      component: (
        <Menu.Item key="tasks-dashboard">
          <Link to="/new-tasks">
            <Icon type="dashboard" />
            <span>Tasks Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "audit-documents": {
      roles: ["project_manager", "admin"],
      auditorAccess: true,
      component: (
        <Menu.Item key="audit-documents">
          <Link to="/audit-documents">
            <Icon type="project" />
            <span>Audit Documents</span>
          </Link>
        </Menu.Item>
      ),
    },
    "escalate-tasks": {
      roles: ["customer_connect", "project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="escalate-tasks">
          <Link to="/escalate-tasks">
            <Icon type="ordered-list" />
            <span>
              Escalate Tasks{" "}
              <span className="gx-bg-danger gx-rounded-circle gx-badge gx-text-white">
                {escalateTaskCount}
              </span>
            </span>
          </Link>
        </Menu.Item>
      ),
    },
    "ticket-list": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="ticket-list">
          <Link to="/ticket-list">
            <Icon type="container" />
            <span>Ticket List</span>
          </Link>
        </Menu.Item>
      ),
    },
    "create-ticket": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="create-ticket">
          <Link to="/create-ticket">
            <i className="icon icon-tag" />
            <span>Create Tickets</span>
          </Link>
        </Menu.Item>
      ),
    },
    "bulk-document-upload-link-generator": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="bulk-document-upload-link-generator">
          <Link to="/bulk-document-upload-link-generator">
            <i className="icon icon-link" />
            <span>Ticket Document Links</span>
          </Link>
        </Menu.Item>
      ),
    },
    "project-list": {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="project-list">
          <Link to="/project-list">
            <i className="icon icon-data-display" />
            <span>Create Project</span>
          </Link>
        </Menu.Item>
      ),
    },
    "project-reports": {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="project-reports">
          <Link to="/project-reports">
            <Icon type="profile" />
            <span>Reports</span>
          </Link>
        </Menu.Item>
      ),
    },
    "project-expense": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="project-expense">
          <Link to="/project-expense">
            <Icon type="account-book" />
            <span>Project Expense</span>
          </Link>
        </Menu.Item>
      ),
    },
    "spare-management": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="spare-management">
          <Link to="/spare-management">
            <Icon type="tool" />
            <span>Spare Management</span>
          </Link>
        </Menu.Item>
      ),
    },
    "partner-invoices": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="partner-invoices">
          <Link to="/partner-invoices">
            <i className="icon icon-feedback" />
            <span>Partner Invoices</span>
          </Link>
        </Menu.Item>
      ),
    },
    "invoice-requests": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="invoice-requests">
          <Link to="/invoice-requests">
            <i className="icon icon-attachment" />
            <span>Invoice Request</span>
          </Link>
        </Menu.Item>
      ),
    },
    "raw-address": {
      roles: ["customer_connect", "project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="raw-address">
          <Link to="/raw-address">
            <Icon type="home" />
            <span>Raw Address</span>
          </Link>
        </Menu.Item>
      ),
    },
    "report-automation": {
      roles: ["admin", "project_manager"],
      component: (
        <Menu.Item key="report-automation">
          <Link to="/report-automation">
            <Icon type="hourglass" />
            <span>Report Automation</span>
          </Link>
        </Menu.Item>
      ),
    },
    "notification-dashboard": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="notification-dashboard">
          <Link to="/notification-dashboard">
            <i className="icon icon-notification" />
            <span>Notifications</span>
          </Link>
        </Menu.Item>
      ),
    },
    escalate_dashboard: {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="escalate_dashboard">
          <Link to="/escalate_dashboard">
            <Icon type="container" />
            <span>Escalation</span>
          </Link>
        </Menu.Item>
      ),
    },
    takeout: {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="takeout">
          <Link to="/takeout">
            <Icon type="vertical-align-bottom" />
            <span>Takeout</span>
          </Link>
        </Menu.Item>
      ),
    },
    "asset-home": {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="asset-home">
          <Link to="/asset-home">
            <Icon type="database" />
            <span>Asset Management</span>
          </Link>
        </Menu.Item>
      ),
    },
    "create-techlocal-ticket": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="create-techlocal-ticket">
          <Link to="/create-techlocal-ticket">
            <i className="icon icon-badge" />
            <span>Techlocal Tickets</span>
          </Link>
        </Menu.Item>
      ),
    },
    escalate: {
      roles: ["coordinator"],
      component: (
        <Menu.Item key="escalate">
          <Link to="/escalate">
            <Icon type="container" />
            <span>Escalate</span>
          </Link>
        </Menu.Item>
      ),
    },
    tools: {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="tools">
          <Link to="/tools">
            <Icon type="tool" />
            <span>Tools</span>
          </Link>
        </Menu.Item>
      ),
    },
    "techlocal-users": {
      roles: ["admin"],
      component: (
        <Menu.Item key="techlocal-users">
          <Link to="/techlocal-users">
            <Icon type="user" />
            <span>TechLocal Users</span>
          </Link>
        </Menu.Item>
      ),
    },
    chat: {
      roles: ["customer_connect", "project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="chat">
          <Link to="/chat">
            <Icon type="message" />
            <span>Chat</span>
          </Link>
        </Menu.Item>
      ),
    },
    "to-do": {
      roles: ["customer_connect", "project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="to-do">
          <Link to="/to-do">
            <Icon type="snippets" />
            <span>To-Do Tasks</span>
          </Link>
        </Menu.Item>
      ),
    },
    surveys: {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="surveys">
          <Link to="/surveys">
            <Icon type="snippets" />
            <span>CSAT Surveys</span>
          </Link>
        </Menu.Item>
      ),
    },
    "create-kci": {
      roles: [
        "customer_connect",
        "project_manager",
        "admin",
        "coordinator",
        "kci",
      ],
      component: (
        <Menu.Item key="create-kci">
          <Link to="/kci">
            <Icon type="snippets" />
            <span>Create KCI</span>
          </Link>
        </Menu.Item>
      ),
    },
    "customer-profiling": {
      roles: ["project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="customer-profiling">
          <Link to="/customer-profiling">
            <Icon type="user-add" />
            <span>Customer Profiling</span>
          </Link>
        </Menu.Item>
      ),
    },
    "whatsapp-msg": {
      roles: ["admin"],
      component: (
        <Menu.Item key="whatsapp-msg">
          <Link to="/whatsapp-msg">
            <Icon type="project" />
            <span>WhatsApp Msg</span>
          </Link>
        </Menu.Item>
      ),
    },
    "auto-allocate": {
      roles: ["admin", "project_manager", "coordinator"],
      component: (
        <Menu.Item key="auto-allocate">
          <Link to="/auto-allocate">
            <Icon type="project" />
            <span>Auto Allocate</span>
          </Link>
        </Menu.Item>
      ),
    },
    "compare-proposal": {
      roles: ["admin"],
      component: (
        <Menu.Item key="compare-proposal">
          <Link to="/compare-proposal">
            <Icon type="ordered-list" />
            <span>Compare Proposal</span>
          </Link>
        </Menu.Item>
      ),
    },
    "tickets-scheduled-today": {
      roles: ["project_manager", "admin"],
      component: (
        <Menu.Item key="tickets-scheduled-today">
          <Link to="/tickets-scheduled-today">
            <Icon type="schedule" />
            <span>Progress</span>
          </Link>
        </Menu.Item>
      ),
    },
    // Additional items for other roles
    "client-dashboard": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="client-dashboard">
          <Link to="/client-dashboard">
            <i className="icon icon-dasbhoard" />
            <span>Dashboard</span>
          </Link>
        </Menu.Item>
      ),
    },
    "ticket-progress": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="ticket-progress">
          <Link to="/ticket-progress">
            <i className="icon icon-data-display" />
            <span>Progress</span>
          </Link>
        </Menu.Item>
      ),
    },
    "client-tasks": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="client-tasks">
          <Link to="/client-tasks">
            <Icon type="unordered-list" />
            <span>Tasks</span>
          </Link>
        </Menu.Item>
      ),
    },
    "client-project-list": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="client-project-list">
          <Link to="/client-project-list">
            <Icon type="container" />
            <span>Projects</span>
          </Link>
        </Menu.Item>
      ),
    },
    "client-create-ticket": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="client-create-ticket">
          <Link to="/client-create-ticket">
            <Icon type="container" />
            <span>Create Ticket</span>
          </Link>
        </Menu.Item>
      ),
    },
    "client-project-create-edit": {
      roles: ["client_admin", "client_user", "client_manager"],
      component: (
        <Menu.Item key="client-project-create-edit">
          <Link to="/client-project-create-edit">
            <i className="icon icon-data-display" />
            <span>Projects Create/Edit</span>
          </Link>
        </Menu.Item>
      ),
    },
    "qc-ticket-list": {
      roles: ["qc"],
      component: (
        <Menu.Item key="qc-ticket-list">
          <Link to="/qc-ticket-list">
            <Icon type="container" />
            <span>Ticket List</span>
          </Link>
        </Menu.Item>
      ),
    },
    "qc-tasks": {
      roles: ["qc"],
      component: (
        <Menu.Item key="qc-tasks">
          <Link to="/qc-tasks">
            <Icon type="unordered-list" />
            <span>Tasks</span>
          </Link>
        </Menu.Item>
      ),
    },
    "kci-tasks": {
      roles: ["kci"],
      component: (
        <Menu.Item key="kci-tasks">
          <Link to="/kci-tasks">
            <Icon type="unordered-list" />
            <span>Tasks</span>
          </Link>
        </Menu.Item>
      ),
    },
    "verify-schedule": {
      roles: ["verify_scheduler"],
      component: (
        <Menu.Item key="verify-schedule">
          <Link to="/verify-schedule">
            <Icon type="hourglass" />
            <span>Verify Schedule</span>
          </Link>
        </Menu.Item>
      ),
    },
    "audit-visits": {
      roles: [],
      auditorAccess: true,
      component: (
        <Menu.Item key="audit-visits">
          <Link to="/audit-visits">
            <Icon type="project" />
            <span>Audit Visits</span>
          </Link>
        </Menu.Item>
      ),
    },
    "work-order-list": {
      roles: ["customer_connect", "project_manager", "admin", "coordinator"],
      component: (
        <Menu.Item key="work-order-list">
          <Link to="/work-order-list">
            <Icon type="ordered-list" />
            <span>Work Orders </span>
          </Link>
        </Menu.Item>
      ),
    },
  };

  // Function to check if user has access to a menu item
  const hasMenuItemAccess = (itemConfig) => {
    if (itemConfig.auditorAccess && role.includes("auditor_user")) {
      return true;
    }
    return itemConfig.roles.includes(user_role);
  };

  // Define menu item categories
  const menuCategories = {
    "dashboard-analytics": {
      title: "Dashboard & Analytics",
      icon: <Icon type="dashboard" />,
      items: [
        "coordinator-dashboard",
        "manager-dashboard",
        "analytics-dashboard",
        "partner-dashboard",
        "client-dashboard",
        "tickets-scheduled-today"
      ],
    },
    "tasks-tickets": {
      title: "Tasks & Tickets",
      icon: <Icon type="unordered-list" />,
      items: [
        "tasks",
        "tasks-dashboard",
        "ticket-list",
        "create-ticket",
        "escalate-tasks",
        "qc-ticket-list",
        "qc-tasks",
        "kci-tasks",
        "client-tasks",
        "client-create-ticket",
        "ticket-progress",
      ],
    },
    projects: {
      title: "Projects",
      icon: <Icon type="project" />,
      items: [
        "coordinator-project-list",
        "project-list",
        "client-project-list",
        "client-project-create-edit",
        "project-reports",
      ],
    },
    "finance-invoicing": {
      title: "Finance & Invoicing",
      icon: <Icon type="account-book" />,
      items: ["invoice-requests", "partner-invoices", "project-expense"],
    },
    operations: {
      title: "Operations & Work Orders",
      icon: <Icon type="tool" />,
      items: [
        "work-order-list",
        "spare-management",
        "audit-documents",
        "audit-visits",
        "raw-address",
        "verify-schedule",
      ],
    },
    "tools-automation": {
      title: "Tools & Automation",
      icon: <Icon type="tool" />,
      items: [
        "tools",
        "bulk-document-upload-link-generator",
        "report-automation",
        "auto-allocate",
        "compare-proposal",
      ],
    },
    communication: {
      title: "Communication & Collaboration",
      icon: <Icon type="message" />,
      items: [
        "chat",
        "to-do",
        "surveys",
        "create-kci",
        "notification-dashboard",
        "customer-profiling",
      ],
    },
    administration: {
      title: "Administration",
      icon: <Icon type="setting" />,
      items: [
        "techlocal-users",
        "create-techlocal-ticket",
        "escalate_dashboard",
        "takeout",
        "asset-home",
        "whatsapp-msg",
        "escalate",
      ],
    },
  };

  // Render ordered menu items grouped by categories
  const renderOrderedMenuItems = () => {
    const orderedKeys = getOrderedMenuItems();

    // Group items by category
    const itemsByCategory = {};
    Object.keys(menuCategories).forEach((categoryKey) => {
      itemsByCategory[categoryKey] = [];
    });

    // Add items to their categories
    orderedKeys.forEach((key) => {
      const itemConfig = menuItems[key];
      if (itemConfig && hasMenuItemAccess(itemConfig)) {
        // Find which category this item belongs to
        for (const [categoryKey, category] of Object.entries(menuCategories)) {
          if (category.items.includes(key)) {
            itemsByCategory[categoryKey].push(itemConfig.component);
            break;
          }
        }
      }
    });

    // Render categories with SubMenu
    return Object.entries(menuCategories)
      .map(([categoryKey, category]) => {
        const categoryItems = itemsByCategory[categoryKey];
        if (categoryItems.length === 0) {
          return null;
        }

        return (
          <SubMenu
            key={categoryKey}
            title={
              <span>
                <span
                  className="icon"
                  style={{ marginRight: 12, display: "inline-block" }}
                >
                  {category.icon}
                </span>
                <span>{category.title}</span>
              </span>
            }
          >
            {categoryItems}
          </SubMenu>
        );
      })
      .filter(Boolean);
  };

  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile info={info} />
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            onClick={handleClick()}
            defaultOpenKeys={defaultOpenCategory ? [defaultOpenCategory] : []}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            {/* Render ordered menu items grouped by categories */}
            {renderOrderedMenuItems()}

            {/*
                        {(user_role === 'admin') && <Menu.Item key="admin-project-listing">
                            <Link to="/admin-project-listing">
                                <i className="icon icon-data-display" />
                                <Icon type="project" />
                                <span>Project Listing</span>
                            </Link>
                        </Menu.Item>}
                        {( user_role === 'admin') && <Menu.Item key="customerfile-ticketlisting">
                            <Link to="/customerfile-ticketlisting">
                                <Icon type="file" />
                                <span>Digital.signoff</span>
                            </Link>
                        </Menu.Item>}
                        {user_role === 'client_admin' || user_role === 'client_user'|| user_role === 'client_manager'  ? <Menu.Item key="client-takeout">
                            <Link to="/client-takeout">
                                <Icon type="vertical-align-bottom" />
                                <span>Takeout</span>
                            </Link>
                        </Menu.Item> : ""}
                        {user_role === 'client_admin' || user_role === 'client_user' ?<Menu.Item key="rate-card">
                            <Link to="/rate-card">
                            <Icon type="form" />
                            <span>Rate Card</span>
                            </Link>
                        </Menu.Item>:""}
                        */}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

class PMTSidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: "",
    };
  }

  componentDidMount() {
    this.getUserDetails();
  }

  getUserDetails = () => {
    fetchUser()
      .then((res) => {
        if (res.data["status"] === 200) {
          this.setState({ cloader: false, userData: res });
          this.props.dispatch(fetchUserInfo(res["data"]["LogedInUserInfo"]));
          localStorage.setItem(
            "user_full_name",
            res["data"]["LogedInUserInfo"].fullname
          );
          localStorage.setItem(
            "user_email_id",
            res["data"]["LogedInUserInfo"].email
          );
          localStorage.setItem(
            "user_uuid",
            res["data"]["LogedInUserInfo"].uuid
          );
          localStorage.setItem(
            "user_phone",
            res["data"]["LogedInUserInfo"].phone
          );
        } else {
          this.setState({ cloader: false });
          message.error("Something went wrong ! please try again.");
        }
      })
      .catch((error) => {
        this.setState({ cloader: false });
        // message.error(error.toString())
      });
  };

  render() {
    return <SidebarContentComp user={this.state.userData} />;
  }
}

const mapStateToProps = ({ auth }) => {
  const {
    loader,
    alertMessage,
    showMessage,
    authUser,
    logedInUser,
    action_count,
  } = auth;
  return {
    loader,
    alertMessage,
    showMessage,
    authUser,
    logedInUser,
    action_count,
  };
};

SidebarContentComp.propTypes = {};
export default connect(mapStateToProps)(PMTSidebarContent);
